import styled from '@emotion/styled';

export default styled.div<{ hide: boolean }>`
  visibility: ${({ hide }) => (hide ? 'hidden' : 'visible')};
  width: ${({ hide }) => (hide ? '0px' : 'auto')};
  height: ${({ hide }) => (hide ? '0px' : 'auto')};
`;
